export default "__VITE_ASSET__433c3410__"